import { FC, useEffect, useState, useMemo} from "react";
import { Col, Collapse, Row, Spin } from "antd";
import { cloneDeep } from "lodash";

import { appInsights, reactPlugin, withAITracking } from "../../../../appInsights";
import CustomTooltip from "@pages/tool-tip";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import { formatDisplayDate } from "@utils/helpers";

import "./endoflife.scss";
import memberDetailsService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import { useEolStore } from "@stores/eolStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../constants/constants";
import { usePatientData } from "@utils/customHooks";

interface IEndOfLife {
  pinChangeHandler: any;
  pinCardIds: any;
  activeKey: any;
  setActivePanels: any;
}

const EndOfLife: FC<IEndOfLife> = ({ pinChangeHandler, pinCardIds, activeKey, setActivePanels }) => {

  const dataCardId = "34";

  const [activeCardPanel, setActiveCardPanel] = useState<any>(activeKey?.includes(dataCardId) ? ["1"] : [])
  // const [loading, setLoading] = useState(false);
  const [eolData, setEolData, isLoading, setIsLoading] =  useEolStore((state) => [state.eolData, state.setEolData, state.isLoading, state.setIsLoading]);

  const { Panel } = Collapse;

  useEffect(() => {
    console.log("EndOfLife.useEffect2");
    appInsights.trackPageView({ name: "Profile" });
  }, []);

  useEffect(()=> {
    setActiveCardPanel(activeKey?.includes(dataCardId) ? ["1"] : [])
  }, [activeKey])

  const {patientId : patientID} = usePatientData();

  const onCollapseChangeHandler = () => {
    if (activeCardPanel.length > 0) {
      setActivePanels(cloneDeep(activeKey)?.filter((item:any) => item !== dataCardId))
    } else {
      //API call is committed because left profile section has a section for terminal illness, incase removed from left profile section API call can be uncommented
      // if(!eolData) {
        // getEolData(["1"]);
      // }
      setActivePanels([...(activeKey ? activeKey : []), dataCardId]);
    };
  };

  const getEolData = (panelExpanded:any) => {
    if (panelExpanded?.length > 0) {
      setIsLoading(true)
        memberDetailsService.getEolRecords(patientID).subscribe({
          next: (response) => {
            const data = response?.data?.data?.endOfLife?.values;

            if (data?.length > 0) {

              let tempEOLHeader: any = ["Disease Name", "First Diagnosed Date", "Last Diagnosed Date"];        
              let tempDiseaseName: any = [];
              let tempFirstDiagnosedDate: any = [];
              let tempLastDiagnosedDate: any = [];
              let tempFirstDiagnosisDayspast: any = [];
              let tempLastDiagnosisDayspast: any = [];
        
              data?.forEach((dataItem: any) => {
                tempDiseaseName.push(dataItem.disease_description);
                tempFirstDiagnosedDate.push(dataItem.first_diagnosis_date);
                tempLastDiagnosedDate.push(dataItem.last_dianosis_date);
                tempFirstDiagnosisDayspast.push(dataItem.first_diagnosis_dayspast);
                tempLastDiagnosisDayspast.push(dataItem.last_diagnosis_dayspast);
              });

              const tempEolData = {
                eolHeader: tempEOLHeader,
                diseaseName: tempDiseaseName,
                firstDiagnosedDate: tempFirstDiagnosedDate,
                lastDiagnosedDate: tempLastDiagnosedDate,
                totalEOLCnt: data[0]?.terminal_disease_count,
                isDataFound: true,
                firstDiagnosisDayspast: tempFirstDiagnosisDayspast,
                lastDiagnosisDayspast: tempLastDiagnosisDayspast,
                patientId: patientID
              }
              setEolData(tempEolData);
            } else {
              setEolData({isDataFound: false});
            }
            setIsLoading(false);
          },
          error: (e) => {
            console.log(e);
            setIsLoading(false);
            setEolData(null);
          },
        });
    } else console.log("Data card is available, no API call");
  }; 
  
  useEffect(() => {
    if(eolData?.patientId !== patientID) {
      setEolData(null);
    }
  }, [patientID]);

  const getHeading = (headerValue: any, tooltipValue: any) => {
    return (
      <>
        <span>{headerValue}</span>
        <CustomTooltip toolTipvalue={tooltipValue} children={<span style={{ margin: "8px" }} className="icon icon-info clr-lightGrayColor"></span>} />
      </>
    );
  };

  const getExtraEle = (id: any) => {
    return (
      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "16px" }}>
          <PinUnpin dataCardId={id} changeHandler={pinChangeHandler} pinCardIds={pinCardIds} />
        </div>
      </div>
    );
  };

  const EolHeaderTitle = (): any => {
    return eolData?.eolHeader?.map((title:any, index:any) => {
      return (
        <Col key={`${title + index}`} span={index === 0 ? 10 : 7}>
          <span className="light-text w500">{title}</span>
        </Col>
      );
    });
  };

  const DiseaseName = (): any => {
    return eolData?.diseaseName.map((data:any, index:any) => {
      return (
        <Row key={`${data + index}`} style={{ marginBottom: "24px", minHeight: "50px" }}>
          <span className="member-key">{data}</span>
        </Row>
      );
    });
  };

  const getDignosedDate = (date: any, isFirstDiagnosedDate: boolean): any => {
    return date.map((currentVal: any, index: number) => {
      const daysPassed = isFirstDiagnosedDate ? eolData?.firstDiagnosisDayspast?.[index] : eolData?.lastDiagnosisDayspast?.[index];
      return (
        <Row key={`${index}`} style={{ marginBottom: "24px", height: "50px" }}>
          <Col>
            <Row>
              <span className="f16 clr-n125 w500">{formatDisplayDate(currentVal, "reminderDateActualFormat", "")}</span>
            </Row>
            <Row>
              <span className="days-remaning">
                {daysPassed}
              </span>
            </Row>
          </Col>
        </Row>
      );
    });
  };

  const headerCnt = eolData?.diseaseName?.length > 0 ? `(${eolData?.diseaseName?.length}/${eolData?.totalEOLCnt})` : "";
  
  return (
    <Collapse accordion bordered={false} expandIconPosition="right" onChange={onCollapseChangeHandler} activeKey={activeCardPanel}>
      <Panel header={getHeading(`Terminal Illness ${eolData ? headerCnt : ""}`, "Terminal Illness")} extra={getExtraEle(dataCardId)} className="eol-title" key="1" style={{ marginBottom: "8px" }}>
        { isLoading ? (
          <Spin spinning={isLoading} indicator={<HealthemSpinner size={50} />}></Spin>
        ) : eolData && eolData?.isDataFound ? (
          <>
            <Row style={{ marginBottom: "24px" }}>
              <EolHeaderTitle />
            </Row>

            <Row style={{ overflowY: "hidden" }}>
              <Col span={10}>
                <DiseaseName />
              </Col>
              <Col span={7}>{getDignosedDate(eolData?.firstDiagnosedDate, true)}</Col>
              <Col span={7}>{getDignosedDate(eolData?.lastDiagnosedDate, false)}</Col>
            </Row>
          </>
        ) : (
          <DataNotFound message={NO_DATA_FOUND} />
        )}
      </Panel>
    </Collapse>
  );
};

export default withAITracking(reactPlugin, EndOfLife);
